define([
	'internal_util/Util',
	'view/UIView',
	'amdi18n-loader?!identity/nls/IdentityExportView_strings',
	'lib/jquery'
], function (
	Util,
	UIView,
	Strings,
	jQuery
) {
	'use strict';

	/**
	 * TODO CloudIDentity Download/Export currently not supported, because Download Servlet was removed.
	 * Consider using a FileSaver (https://github.com/eligrey/FileSaver.js) or something similar in future if such a functionality is needed again.
	 */
	function IdentityExportView(exportCallback) {
		var _exportCallback = exportCallback,
			_view;

		_view = (function () {
			var $view = jQuery(
					"<div id='skIdS_identity-export-container'>" +
						"<p>" + Strings.message_text + "</p>" +
						"<button id='skIdS_identity-export-button' class='btn btn-default'>" + Strings.download_cloud_identity + "</button>" +
					"</div>");

			$view.find('#skIdS_identity-export-button').on('click', function () {
				Util.callCallbacks(_exportCallback);
			});

			return $view;
		})();

		UIView.call(this);


		// public methods

		this.get = function () {
			return _view;
		};

		this.update = function () {
			// nothing to do
		};
	}

	IdentityExportView.prototype = Object.create(UIView.prototype);

	return IdentityExportView;
});


//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/view/identity/IdentityExportView.js
// module id = 337
// module chunks = 1